// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockPayments_wrapper__PEY5g","title":"BlockPayments_title__grBFO","icons":"BlockPayments_icons__AT_Dd"};